/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_OverlineInputs */

const en_mk_tb_overline = /** @type {(inputs: Mk_Tb_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Build · for teams of 2–10`)
};

const id_mk_tb_overline = /** @type {(inputs: Mk_Tb_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Build · untuk tim 2–10 orang`)
};

/**
* | output |
* | --- |
* | "Team Build · for teams of 2–10" |
*
* @param {Mk_Tb_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_overline = /** @type {((inputs?: Mk_Tb_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_overline(inputs)
	return en_mk_tb_overline(inputs)
});